import React, { Fragment, createRef, Component } from "react";

import PropTypes from "prop-types";
import classnames from "classnames";
import { Highlight } from "react-instantsearch-dom";
import Carousel from "../components/Carousel";
import GalleryModal from "../location/thumbnailGallery/GalleryModal";
import withThumbGalleryState from "../HOC/withThumbGalleryState";

class Hit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            matchedImages: null,
        };
        this.container = createRef();
    }

    static getDerivedStateFromProps(props, state) {
        if (!!props.hit._highlightResult.tags) {
            props.hit._highlightResult.tags = props.hit._highlightResult.tags.filter(
                tag => {
                    return tag.matchLevel !== "none";
                }
            );
        }
        let matchedImages = [];

        state.matchedImages = matchedImages;

        return state;
    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    render() {
        return (
            <Fragment>
                <li className={classnames('px-2', (typeof viewMap === 'undefined' || viewMap === true) && !!!this.props.showMap && !!!this.props.feature ? 'col-sm-6 col-md-4 col-lg-3' : 'col-md-4', !!this.props.feature ? 'first-locations sm-feature mb-2' : null)}>
                    <article ref={this.container} className="il-search-result">

                        <div className="il-react-carousel d-flex flex-column il-xs-carousel-container">
                            <div className="order-1 il-search-result-info">

                                <Carousel
                                    mediaTags={this.props.mediaTags}
                                    locationSlug={this.props.hit.slug}
                                    isActive={this.props.isActive}
                                    onActiveCallback={this.props.onActiveCallback}
                                    locationId={this.props.hit.id}
                                    title={this.props.hit.title}
                                />

                                <div className="py-2 il-location-text position-relative">
                                    {!!this.props.feature && this.props.hit.is_exclusive && (
                                        <span className="il-sub-title font-weight-bold mb-1">Exclusive</span>
                                    )}
                                    <h5 className="location-name font-weight-normal truncate mb-0">
                                        <a
                                            className="text-body"
                                            target="_blank"
                                            href={`/${this.props.hit.slug}`}
                                        >
                                            <Highlight
                                                attribute="title"
                                                hit={this.props.hit}
                                            />
                                        </a>
                                    </h5>
                                    <p className="location-city ellipse-overflow h6 mb-0">
                                        <span className="text-dark h6 small mr-2" target="_blank" href="#">
                                            {!!this.props.hit.city && (
                                                <Highlight
                                                    attribute="city"
                                                    hit={this.props.hit}
                                                />
                                            )}
                                        </span>
                                    </p>
                                    {!!this.props.feature && (
                                        <a className="d-inline-block btn btn-primary mt-3" href={`/${this.props.hit.slug}`}>View Location</a>
                                    )}
                                    <div className="truncate tags h6">
                                        <Highlight
                                            attribute="tags"
                                            hit={this.props.hit}
                                        />
                                    </div>

                                    <button
                                        className="mt-1 il-thumb-gallery-modal-trigger btn text-primary position-absolute"
                                        data-toggle="modal"
                                        data-target="#il-thumb-gallery-modal"
                                        onClick={this.props.handleShow}
                                    >
                                        <svg className="align-top" width="25" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M319.8 204v8c0 6.6-5.4 12-12 12h-84v84c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12v-84h-84c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h84v-84c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12zm188.5 293L497 508.3c-4.7 4.7-12.3 4.7-17 0l-129-129c-2.3-2.3-3.5-5.3-3.5-8.5v-8.5C310.6 395.7 261.7 416 208 416 93.8 416 1.5 324.9 0 210.7-1.5 93.7 93.7-1.5 210.7 0 324.9 1.5 416 93.8 416 208c0 53.7-20.3 102.6-53.7 139.5h8.5c3.2 0 6.2 1.3 8.5 3.5l129 129c4.7 4.7 4.7 12.3 0 17zM384 208c0-97.3-78.7-176-176-176S32 110.7 32 208s78.7 176 176 176 176-78.7 176-176z"></path></svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </article>
                </li>
                <GalleryModal
                    locationId={this.props.hit.id}
                    title={this.props.hit.title}
                    show={this.props.show}
                    handleClose={this.props.handleClose} />
            </Fragment>
        );
    }
}

Hit.propTypes = {
    hit: PropTypes.object.isRequired
};

export default withThumbGalleryState(Hit);
